import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import toast from 'react-hot-toast';
import PublicHeader from '../components/PublicHeader';
import PublicFooter from '../components/PublicFooter';
import PasswordInput from '../components/ui/PasswordInput';

export default function RegisterPage() {
  const navigate = useNavigate();
  const { register } = useAuth();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirmation, setPasswordConfirmation] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== passwordConfirmation) {
      toast.error('Les mots de passe ne correspondent pas');
      return;
    }
    setLoading(true);
    try {
      await register(name, email, password, passwordConfirmation);
      toast.success('Compte créé ! Bienvenue.');
      navigate('/admin/surveys');
    } catch (err) {
      const msg = err.response?.data?.message
        || err.response?.data?.errors
          ? Object.values(err.response.data.errors || {}).flat().join(' ')
          : 'Erreur lors de l\'inscription';
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col">
      <PublicHeader />
      <main id="main-content" className="flex-1 flex items-center justify-center pt-16 p-4" tabIndex={-1}>
        <div className="w-full max-w-md">
          <div className="bg-white rounded-xl shadow-lg p-8">
            <h1 className="text-2xl font-bold text-slate-800 mb-2 text-center">Créer mon compte</h1>
            <p className="text-slate-500 text-sm text-center mb-6">
              1 sondage gratuit pour tester
            </p>
            <form onSubmit={handleSubmit} className="space-y-4" aria-label="Formulaire d'inscription">
              <div>
                <label htmlFor="register-name" className="block text-sm font-medium text-slate-700 mb-1">Nom (optionnel)</label>
                <input
                  id="register-name"
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  autoComplete="name"
                  className="w-full px-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent min-h-[44px]"
                  placeholder="Votre nom"
                />
              </div>
              <div>
                <label htmlFor="register-email" className="block text-sm font-medium text-slate-700 mb-1">Email</label>
                <input
                  id="register-email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  autoComplete="email"
                  aria-required="true"
                  className="w-full px-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent min-h-[44px]"
                  placeholder="votre@email.com"
                />
              </div>
              <PasswordInput
                id="register-password"
                label="Mot de passe"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                minLength={8}
                autoComplete="new-password"
                aria-required="true"
                placeholder="Min. 8 caractères"
              />
              <PasswordInput
                id="register-password-confirm"
                label="Confirmer le mot de passe"
                value={passwordConfirmation}
                onChange={(e) => setPasswordConfirmation(e.target.value)}
                required
                minLength={8}
                autoComplete="new-password"
                aria-required="true"
                placeholder="Répétez le mot de passe"
              />
              <button
                type="submit"
                disabled={loading}
                aria-busy={loading}
                className="w-full py-2 px-4 min-h-[44px] bg-primary-600 text-white font-medium rounded-lg hover:bg-primary-700 disabled:opacity-50 focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
              >
                {loading ? 'Inscription...' : 'Créer mon compte'}
              </button>
            </form>
            <p className="mt-6 text-sm text-slate-500 text-center">
              Déjà un compte ?{' '}
              <Link to="/login" className="text-primary-600 hover:underline">Se connecter</Link>
            </p>
          </div>
        </div>
      </main>
      <PublicFooter />
    </div>
  );
}
